<div class="title">{{ title() | translate }}</div>
@for (item of items(); track item.path) {
  <a
    class="nav-item"
    [routerLink]="item.path"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: !!item.exact }"
    (click)="linkClick.emit()"
  >
    <app-icon [name]="item.icon" [size]="16" />
    <span class="label">{{ item.labelKey | translate }}</span>
  </a>
}
